// ROOM API
import Request from '../base'
export default {
  save (options) {
    return Request.post('/ebermain/mainapi/aims/room/save', options)
  },
  delete (options) {
    return Request.post('/ebermain/mainapi/aims/room/delete', options)
  },
  load (options) {
    return Request.post('/ebermian/mainapi/aims/room/load', options)
  },
  list (options) {
    return Request.post('/ebermain/mainapi/aims/room/list', options)
  },
  find (pagination, options) {
    if (!pagination.sort) {
      pagination.sort = 'name'
    }
    if (!pagination.order) {
      pagination.order = 'ASC'
    }
    return Request.post('/ebermain/mainapi/aims/room/find', Request.paginationBody(options, pagination))
  }
}
